import { useEffect, useState } from 'react'

import { useScroll } from '../../context/ScrollContext'

interface UseElementScrollPositionProps {
  elementRef: React.RefObject<HTMLElement | null>
  containerRef: React.RefObject<HTMLElement | null>
  offsetRem?: number
}

export function useElementScrollPosition({
  elementRef,
  containerRef,
  offsetRem = 0,
}: UseElementScrollPositionProps) {
  const [position, setPosition] = useState({
    top: 0,
    bottom: 0,
    visible: false,
  })

  const { subscribe } = useScroll()

  useEffect(() => {
    if (!elementRef.current || !containerRef.current) return

    const getOffsetPx = () => {
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      )
      return offsetRem * rootFontSize
    }

    const updatePosition = () => {
      if (!elementRef.current || !containerRef.current) return

      const elRect = elementRef.current.getBoundingClientRect()
      const containerRect = containerRef.current.getBoundingClientRect()
      const offset = getOffsetPx()

      const top = elRect.top - containerRect.top
      const bottom = elRect.bottom - containerRect.top
      const visible = bottom > offset && top < containerRect.height - offset

      setPosition({ top, bottom, visible })
    }

    updatePosition()
    return subscribe(updatePosition)
  }, [elementRef, containerRef, offsetRem, subscribe])

  return position
}
